import store from "@/store/index.js";
import { getLocalStorage } from "@/tools/localStorage.js";
import { get, post, put, del } from "@/tools/request.js";

// 取得結帳資訊
export function getCashier(coupon = "", payment = 0, shipping = 0, shopCart) {
  let data = {
    CouponCode: coupon, //優惠代碼
    PaymentID: payment, //付款方式
    ShippingID: shipping, //物流方式
    ShoppingCart: [], //購物車內容
  };
  // 依照傳入的購物車資訊提取API需要的資料放入ShoppingCart中
  shopCart.forEach((item) => {
    for (let i = 0; i < item.amount; i++) {
      if (item.isCustom == "Y") {
        data.ShoppingCart.push({
          GoodsID: item.productData.GoodsID, //商品ID
          CustomSpecID: item.activeOption.join(), //規格ID組合
        });
      } else {
        data.ShoppingCart.push({
          GoodsID: item.productData.GoodsID, //商品ID
          ColorID: item.activeOption[0], //選項一ID
          SizeID: item.activeOption[1], //選項二ID
        });
      }
    }
  });

  if (getLocalStorage("account_token")) {
    // 會員API
    return post("member/cashier", data);
  } else {
    // 無會員API
    return post("nonMember/cashier", data);
  }
}

// 送出結帳
export function SendCheckout(userData, shopCart) {
  // 篩選郵遞區號
  let zipCode = 0;
  if (userData.consigneeCity != "" && userData.consigneeArea != "") {
    zipCode = store.state.zipCodeData.filter(
      (item) =>
        item.City == userData.consigneeCity &&
        item.Area == userData.consigneeArea
    )[0].ZipCode;
  }

  let data = {
    BuyerName: userData.buyerName, //購買者姓名
    BuyerPhone: userData.buyerPhone, //購買者電話
    ReceiverName: userData.consigneeName, //收件人姓名
    ReceiverPhone: userData.consigneePhone, //收件人電話
    ReceiverEmail: userData.consigneeEmail, //收件人Email
    ReceiverAddressCode: zipCode, //收件郵遞區號
    ReceiverAddress: userData.consigneeAddress, //收件地址
    ReceiverMemo: userData.comment, //訂單備註
    CouponCode: userData.coupon, //優惠代碼
    PaymentID: userData.payWay, //付款方式
    ShippingID: userData.shipWay, //物流方式
    Installment: userData.installment, //分期期數
    ReceiverStoreNo: "", //超商取貨ID
    ReceiverStoreInfo: "", //超商取貨門市資訊
    OrderMemo: "", //分潤標籤
    ShoppingCart: [], //購物車
  };

  // 如果是超商取貨
  let shipData = store.state.shipwayData.filter(
    (item) => item.ShippingID == data.ShippingID
  )[0];
  if (
    shipData.ShippingType == "FAMIC2C" ||
    shipData.ShippingType == "UNIMARTC2C"
  ) {
    data.ReceiverStoreNo = userData.shopID;
    data.ReceiverStoreInfo = userData.shopName;
  }
  // 如果有分潤標籤
  if (getLocalStorage("orderMemo")) {
    data.OrderMemo = getLocalStorage("orderMemo");
  }
  // 如果有會員ID
  if (userData.AutoLoginMemberID) {
    data.AutoLoginMemberID = userData.AutoLoginMemberID;
  }

  // 依照傳入的購物車資訊提取API需要的資料放入ShoppingCart中
  shopCart.forEach((item) => {
    for (let i = 0; i < item.amount; i++) {
      if (item.isCustom == "Y") {
        data.ShoppingCart.push({
          GoodsID: item.productData.GoodsID,
          CustomSpecID: item.activeOption.join(),
        });
      } else {
        data.ShoppingCart.push({
          GoodsID: item.productData.GoodsID,
          ColorID: item.activeOption[0],
          SizeID: item.activeOption[1],
        });
      }
    }
  });

  if (getLocalStorage("account_token")) {
    // 會員API
    return post("member/checkout", data);
  } else {
    // 無會員API
    return post("nonMember/checkout", data);
  }
}

// 取得7-11門市地圖
export function Get711Map() {
  if (getLocalStorage("member_token")) {
    //有會員API
    return get("member/711Map");
  } else {
    //無會員API
    return get("nonMember/711Map");
  }
}

// 取得全家門市地圖
export function GetFamilyMap() {
  if (getLocalStorage("member_token")) {
    //有會員API
    return get("member/FamilyMap");
  } else {
    //無會員API
    return get("nonMember/FamilyMap");
  }
}

// 非會員查詢訂單
export function GetOrder(tradeID, phone) {
  let data = {
    TradeID: tradeID, //訂單編號
    BuyerPhone: phone, //訂購人電話
  };
  return post("nonMember/trade", data);
}

// 會員加入購物車
export function AddShopCart(product, amount) {
  let promise_list = [];
  // 因為加入購物車API一次只能傳入一個商品，所以要依照使用者選擇的商品數量，數量有幾個API就要呼叫幾次
  for (let i = 0; i < amount; i++) {
    promise_list.push(put("member/shoppingCart", product));
  }

  return Promise.all(GetPromise(promise_list)).then(
    (res) => {
      if (promise_list.length == res.length) {
        let error = false;
        res.forEach((item) => {
          item.code != 200 ? (error = item) : "";
        });
        return error != false ? error : res[0];
      }
    },
    (err) => console.log(err)
  );
}

// 會員移除購物車商品
export function RemoveShopCart(removeList) {
  let promiseList = [];
  // 因為移除購物車API一次只能傳入一個商品，所以要依照使用者選擇的商品數量，數量有幾個API就要呼叫幾次
  for (let i = 0; i < removeList.length; i++) {
    promiseList.push(del("member/shoppingCart/" + removeList[i]));
  }
  return Promise.all(GetPromise(promiseList)).then(
    (res) => {
      if (promiseList.length == res.length) {
        let error = false;
        res.forEach((item) => {
          item.code != 200 ? (error = item) : "";
        });
        return error != false ? error : res[0];
      }
    },
    (err) => console.log(err)
  );
}

// 取得會員購物車資料
export function GetShopCart() {
  return get("member/shoppingCart");
}

export function GetLinePayResult(transactionId, orderId) {
  return post(
    "LineReply/notify?transactionId=" + transactionId + "&orderId=" + orderId
  );
}

export function GetPaypalCapture(id) {
  return post("Paypal/capture?token=" + id);
}
export function CancelPaypalOrder(id) {
  return post("Paypal/cancel?token=" + id);
}
function GetPromise(promiseList) {
  return promiseList.map((promise) => promise.then((res) => res));
}
